const baseUrl = 'https://v2.jokeapi.dev/';

export const API = {
	jokeapi: `${baseUrl}joke`
};
